module.exports = __webpack_public_path__ + "static/img/contact-kf.0103b506.png";